import React, { useState, useEffect } from 'react';

const API_URL = '/api/content';

const Network = () => {
  const [data, setData] = useState({ highlights: [], title: '', description: '' });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await fetch(`${API_URL}/network`);
      const result = await res.json();
      if (result && typeof result === 'object') {
        setData(result);
      }
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const highlights = data.highlights?.length > 0 ? data.highlights : [
    { number: "100+", label1: "Projects", label2: "Completed" },
    { number: "20+", label1: "Global", label2: "Clients" },
    { number: "4", label1: "Manufacturing", label2: "Factories" }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 mb-16">
        <div className="text-center">
          <div className="flex items-center justify-center mb-6">
            <div className="flex-1 h-px bg-gray-300"></div>
            <h2 className="text-4xl font-bold text-gray-900 px-8">
              {data.title || 'OUR CUSTOMERS'}
            </h2>
            <div className="flex-1 h-px bg-gray-300"></div>
          </div>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
            {data.description || 'LEMASX specializes in Design, CAE Analysis, and Precision Machining.'}
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-4 gap-12 items-stretch">
          <div className="lg:col-span-1 bg-gradient-to-br from-pink-600 to-pink-800 rounded-lg p-8 flex items-center">
            <div className="grid grid-cols-1 gap-6 w-full">
              {highlights.map((item, index) => (
                <div key={index} className="text-center">
                  <div className="text-4xl font-bold text-white mb-2">{item.number}</div>
                  <div className="text-sm text-pink-100">
                    <div>{item.label1}</div>
                    <div>{item.label2}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="lg:col-span-3 relative">
            <div className="bg-gradient-to-br from-pink-600 to-pink-800 rounded-lg h-[500px] flex items-center justify-center overflow-hidden">
              <img 
                src="/assets/images/global-image.png" 
                alt="Global Manufacturing Network" 
                className="w-full h-full object-fill"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Network;
